import { render } from "./HeroiconsOutlineWifi.vue?vue&type=template&id=77cf4ae9"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineWifi.vue"]])

export default __exports__